
import React, { useEffect, useRef, useState } from 'react';
import Save from "../../assets/save.svg";
import { Modal } from 'flowbite-react';
import * as XLSX from 'xlsx';
import AttachmentModalProps from "./AttachmentModalProps";
import { ZoomHandler, ZoomMode, cursorImage } from '../../helpers/zoomHelpers'

export const RenderExcel = ({ media, file_obj, disabled, onRemove, component, isReplyMessage }: AttachmentModalProps) => {
    const modalBodyRef = useRef<HTMLDivElement | null>(null);
    const contentContainerRef = useRef<HTMLDivElement>(null);
    const [selectedFile, setSelectedFile] = useState<string | null>(null);
    const [content, setContent] = useState<string | null>(null);
    const [status, setStatus] = useState<string>('');
    const [scale, setScale] = useState(1);
    const [zoomMode, setZoomMode] = useState(ZoomMode.IN);
    const modalBodyClass = 'w-full';

    const openModal = async (url: string) => {
        setScale(1);
        setStatus('Загрузка документа...');
        setSelectedFile(url);
        try {
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            const data = new Uint8Array(arrayBuffer);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const tableHtml = XLSX.utils.sheet_to_html(worksheet);
            setContent(tableHtml);
        } catch (e) {
            console.error(e);
            setStatus('Ошибка загрузки документа');
        }
    };

    const closeModal = () => {
        setSelectedFile(null);
        setStatus('');
        setScale(1);
        setZoomMode(ZoomMode.IN)
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalBodyRef.current && !modalBodyRef.current.contains(event.target as Node)) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function applyZooms(scale: number, event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        const container = modalBodyRef?.current?.getElementsByClassName(modalBodyClass)[0];
        const content = contentContainerRef?.current;

        if (container && content) {
            new ZoomHandler().applyZooms(
                scale,
                event,
                container,
                content
            )
        } else {
            console.error('Container or content not found');
        }
    }

    const handleImageClick = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        switch (zoomMode) {
            case ZoomMode.DISABLE:
                break
            case ZoomMode.IN:
                const newScaleValue = scale + 1;
                setScale(newScaleValue);
                applyZooms(newScaleValue, event);
                setZoomMode(ZoomMode.OUT)
                break
            case ZoomMode.OUT:
                if (scale > 1) {
                    const newScale = scale - 1;
                    setScale(newScale);
                    applyZooms(newScale, event);
                    setZoomMode(ZoomMode.IN)
                }
                break
        }
    };

    return (
        <>
            {media && component({
                media: media, onClick: () => openModal(media.file),
                isReplyMessage: isReplyMessage
            })}
            {file_obj && component({
                file_obj: file_obj,
                disabled: disabled,
                onRemove: onRemove,
                isReplyMessage: isReplyMessage,
                onClick: () => openModal(file_obj.media_info.file)
            })}
            {/* Модальное окно на весь экран для файла */}
            <Modal
                size={'6xl'}
                ref={modalBodyRef}
                style={{
                    transformOrigin: '0 0'
                }}
                show={selectedFile !== null}
                onClose={closeModal}>
                <Modal.Header className={"overflow-hidden whitespace-pre-wrap break-word-only-long"}>
                    {media && media.original_name || file_obj && file_obj.media_info.original_name}
                </Modal.Header>
                <Modal.Body className={modalBodyClass}>
                    <div className="w-full h-full object-contain">
                        {content ? (
                            <div
                                ref={contentContainerRef}
                                onClick={handleImageClick}
                                style={{
                                    transform: `scale(${scale})`,
                                    transformOrigin: '0 0',
                                    cursor: cursorImage(zoomMode)
                                }}
                                className="w-full h-auto overflow-auto"
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        ) : (
                            <div className="h-full w-full flex flex-row justify-center items-center">{status}</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="flex w-full justify-center gap-2">
                        <a
                            className="w-10 p-2 flex flex-row justify-center items-center gap-1 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400"
                            href={media?.file || file_obj?.media_info?.file}
                            target={'_blank'}
                        >
                            <img src={Save} alt="download file" />
                        </a>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};
